import { createContext } from 'react';

const CollaborationContext = createContext();

export default CollaborationContext;
